import { chartColorCode } from '../../../shared-components/chart/colorCodes';
import {
  TOTAL,
  SADNESS,
  FEAR,
  ANGER,
  JOY,
  NEUTRAL,
  NEGATIVE,
  POSITIVE,
} from '../../redux/constants';
export const CHOOSE_TOPICS_COMPARE_TITLE = 'Choose 1-2 topics to compare with';
export const COMPARE_CONTAINER_CLASS = 'compare-container';
export const COMPARE_HEADER_CLASS = 'compare-header';
export const COMPARE_BODY_CLASS = 'compare-body';
export const TITLE_CHOOSE_TOPIC_CLASS = 'title-choose-topics';
export const MAIN_TOPIC_NAME_CLASS = 'main-topic-name';
export const CATEGORY_CONTAIN_TOPIC_CLASS = 'category-contain-topic';
export const CATEGORY_LABEL_CLASS = 'category-label';
export const DISABLED_CLASS = ' disabled';
export const CHECKBOX_WITH_LABEL_CLASS_ACTIVE = 'checkbox-with-label-active';
export const CHECKBOX_WITH_LABEL_CLASS = 'checkbox-with-label';
export const COMPARE_TOPIC_CHECKBOX_CLASS = 'compare-topic-checkbox';
export const MAXIMUM_SELECTED_TOPICS = 2;
export const SPAN_EMPTY_CHECKBOX = 'span-empty-checkbox';
export const BUTTON_COMPARE_CLASS = 'btn btn-submit';
export const CHECKBOX_TYPE = 'checkbox';
export const COMPARE_BODY_COMPARING = 'compare-body-comparing';

export const DASHBOARD_FILTER_LOCALSTORAGE = 'dashboardFilter';

export const MAX_DAYS_FOR_TIME_CONSTANT_1_TICK_LABELS = 21;
export const MIN_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS = 21;
export const MAX_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS = 90;
export const MIN_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS = 90;
export const MAX_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS = 180;
export const MIN_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS = 180;
export const MAX_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS = 365;
export const TIME_CONSTANT = 24 * 3600 * 1000;

export const DATE_TIME_IN_YYYY_MM_DD_FORMAT = 'YYYY-MM-DD';

export const TOPIC_COMPARE_CLASS = 'topic-compare-text';
export const CHANGE_TOPIC_ACTION_CLASS = 'change-topic-action';
export const TOPIC_COMPARED_TEXT = 'Topics compared:';
export const CHANGE_TOPIC_TEXT = 'change topics';

export const COMPARE_CHART_MAIN = 'compare-chart-main';

export const COMPARE_CHART_LEGENDS = [
  {
    key: TOTAL,
    text: 'Total Mentions',
    color: chartColorCode.totalMentions,
  },
  {
    key: POSITIVE,
    text: 'Positive Mentions',
    color: chartColorCode.positive,
  },
  {
    key: NEGATIVE,
    text: 'Negative Mentions',
    color: chartColorCode.negative,
  },
  {
    key: NEUTRAL,
    text: 'Neutral Mentions',
    color: chartColorCode.neutral,
  },
  {
    key: JOY,
    text: 'Joy Index',
    color: chartColorCode.joy,
  },
  {
    key: ANGER,
    text: 'Anger Index',
    color: chartColorCode.anger,
  },
  {
    key: FEAR,
    text: 'Fear Index',
    color: chartColorCode.fear,
  },
  {
    key: SADNESS,
    text: 'Sad Index',
    color: chartColorCode.sadness,
  },
];

export const HIGH_CHART_CONTAINER_CLASS = 'high-chart-container';
export const TOPIC_NAME_FOR_TWO_CHARTS_CLASS = 'topic-name-for-two-charts';
export const SPAN_BETWEEN_TWO_CHARTS = 'span-between-two-charts';

export const LIST_CHARTS = {
  emotion: {
    name: 'Emotions Trend',
    id: 'chart103',
    chartType: 'line',
  },
  sentiment: {
    name: 'Sentiments Trend',
    id: 'chart102',
    chartType: 'areaspline',
  },
};



// WEBPACK FOOTER //
// ./src/features/home/components/constants/CompareConstants.js